export default "__VITE_ASSET__DglyLJRF__"